/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Manual_Removal_Native_WrapperInputs */

const en_delete_account_manual_removal_native_wrapper = /** @type {(inputs: Delete_Account_Manual_Removal_Native_WrapperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account has been deleted. To remove remaining data from this device, uninstall the app.`)
};

const es_delete_account_manual_removal_native_wrapper = /** @type {(inputs: Delete_Account_Manual_Removal_Native_WrapperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta ha sido eliminada. Para eliminar los datos restantes de este dispositivo, desinstala la aplicación.`)
};

const ar_delete_account_manual_removal_native_wrapper = /** @type {(inputs: Delete_Account_Manual_Removal_Native_WrapperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم حذف حسابك. لإزالة البيانات المتبقية من هذا الجهاز، ألغِ تثبيت التطبيق.`)
};

/**
* | output |
* | --- |
* | "Your account has been deleted. To remove remaining data from this device, uninstall the app." |
*
* @param {Delete_Account_Manual_Removal_Native_WrapperInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_manual_removal_native_wrapper = /** @type {((inputs?: Delete_Account_Manual_Removal_Native_WrapperInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Manual_Removal_Native_WrapperInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_manual_removal_native_wrapper(inputs)
	if (locale === "es") return es_delete_account_manual_removal_native_wrapper(inputs)
	return ar_delete_account_manual_removal_native_wrapper(inputs)
});